import Img1 from '../Assets/img1.png'
import Img2 from '../Assets/img2.png'
import Img3 from '../Assets/img3.png'

export const data = [
    {
        type: 'Text',
        txt: 'Hey, how are you? Welcome to Particles Demo!',
        timeLine: [1000, 3000, 500, 500, 3000, 500, 500, 1500]
    },

    {
        type: 'Text',
        txt: 'Multiple segments of text can be displayed in sequence, with each segment appearing after a specified time interval.',
        timeLine: [1000, 2000, 500, 500, 500, 500, 500, 500, 500, 3000, 500, 500, 500, 500, 500, 500, 500, 1500]
    },

    {
        type: 'Text',
        txt: "And you can also display images!",
        timeLine: [500, 3000, 500, 500, 500, 2000]
    },

    {
        type: 'Image',
        img: [Img1, Img2, Img3],
        timeLine: [3000, 4000, 4000]
    },

    {
        type: 'Text',
        txt: 'And lastly here is a flower for you (❁´◡`❁)',
        timeLine: [2000, 3000, 500, 500, 500, 500, 500, 500, 2000]
    },

    {
        type: 'Model',
        model: './lily/scene.gltf',
        timeLine: 2000
    }
]